export default __webpack_public_path__ + "static/media/cellphone.92a3b4f1.svg";